var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveSiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 7.83366C14.6587 5.75766 14.5934 4.65699 13.884 3.94833C13.1034 3.16699 11.846 3.16699 9.33203 3.16699H6.66536C4.15136 3.16699 2.89403 3.16699 2.11336 3.94833C1.3327 4.72966 1.33203 5.98633 1.33203 8.50033C1.33203 11.0143 1.33203 12.2717 2.11336 13.0523C2.8947 13.833 4.15136 13.8337 6.66536 13.8337H7.66536",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8194 10.3177L9.81956 10.3502M9.81956 10.3502L11.1637 11.6726M9.81956 10.3502L11.142 9.00604M9.84393 13.3501L13.8438 13.3176M13.8438 13.3176L12.5213 14.6617M13.8438 13.3176L12.4997 11.9951",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66536 11.167H3.9987M1.33203 7.16699H14.6654",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveSiteIcon);
export default __webpack_public_path__ + "static/media/move_site_icon.cc93023dd8c3c45a7604a4b25f763bd1.svg";
export { ForwardRef as ReactComponent };